import React from 'react'
import { BillboardText, colors, LayoutBand, Paragraph, Row } from '@fs/zion-ui'
import { NoticeImportant } from '@fs/zion-icon'

export default function DebugErrorNotice({ errorLabel = 'Error loading image data', error }) {
  return (
    <LayoutBand marginY="nano" data-testid="element-tree-view-error">
      <BillboardText primaryColor={colors.danger60}>
        <Row alignY="middle" gutters="nano">
          <NoticeImportant background={colors.danger60} color={colors.gray00} size="xs" />
          <Paragraph size="sm">{`${errorLabel}: ${error?.message}`}</Paragraph>
        </Row>
      </BillboardText>
    </LayoutBand>
  )
}
